import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { VolunteeringMentorsService } from '../volunteering-mentors.service';
import { AcceptedSignUpsViewPart } from './accepted-sign-ups/accepted-sign-ups.part';
import { VolunteeringAllMentorsViewPart } from './all-mentors/all-mentors-view.part';
import { BackUpsViewPart } from './back-ups/back-ups.part';
import { VolunteeringMentorDropoutsViewPart } from './dropped-out-mentord/dropped-out-mentors-view.part';
import { MentorPoolViewPart } from './mentor-pool/mentor-pool.part';
import { PendingSignUpsViewPart } from './pending-sign-ups/pending-sign-ups.part';
import { RejectedSignUpsViewPart } from './rejected-sign-ups/rejected-sign-ups.part';

@Component({
	selector: 'volunteering-mentors-views-part',
	standalone: true,
	imports: [
		MentorPoolViewPart,
		PendingSignUpsViewPart,
		RejectedSignUpsViewPart,
		AcceptedSignUpsViewPart,
		BackUpsViewPart,
		VolunteeringAllMentorsViewPart,
		VolunteeringMentorDropoutsViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-mentors-views.part.html',
})

export class VolunteeringMentorsViewsPart implements OnInit {

	public service = inject(VolunteeringMentorsService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}